import React from 'react';
import { Button } from 'quantux-ui';
import { css, StyleSheet } from 'aphrodite/no-important';

import { blue, gray, salmon } from '../../theme';

const PayerCardLarge = (props) => {
  const styles = StyleSheet.create({
    aboutContainer: {
      width: '359px',
      height: props.height,
      minHeight: props.height, // '323px'
      background: blue[800],
      borderRadius: '4px',
      padding: '8px',
      color: gray[200],
      fontSize: '14px',
      fontWeight: '700'
    },
    headingText: {
      fontSize: '14px',
      marginLeft: '8px',
      minWidth: '250px',
      maxWidth: '250px',
      paddingRight: '4px'
    },
    headingTitle: {
      fontWeight: 'bold'
    },
    headingPayerCode: {
      color: blue[200]
    },
    ellipsisContainer: {
      width: '20px',
      height: '20px',
      minWidth: '20px',
      minHeight: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: blue[200],
      borderRadius: '4px',
      color: blue[800]
    },
    apwItem: {
      display: 'flex',
      alignItems: 'center'
    },
    apwError: {
      color: salmon[500]
    },
    apwIconContainer: {
      width: '24px'
    },
    apwIcon: {
      fontSize: '28px'
    }
  });

  const {
    // payerName,
    address = {},
    phone = '',
    fax = '',
    website = '',
    email = '',
    servicingStates = ''
  } = props.data;

  let pWebsite = '';
  if (website.indexOf('://') === -1) {
    pWebsite = `http://${website}`;
  } else {
    pWebsite = website;
  }

  let pPhoneUrl = '';
  if (phone.length > 0) {
    const tmp = phone.replace(/-/g, '');
    pPhoneUrl = `tel:+1${tmp}`;
  }

  let pAddressUrl = '';
  if (address.streetAddress1) {
    const tmpAddress = `${address.streetAddress1} ${address.city} ${address.state} ${address.zip.substring(0, 5)}`;
    pAddressUrl = 'https://www.google.com/maps/search/?api=1&query=' + encodeURI(tmpAddress);
  }

  return (
    <div className={`${props.className} ${css(styles.aboutContainer)}`}>
      {/* Header */}
      <div className='fx'>
        <img
          alt='payer avatar'
          style={{ maxHeight: '64px', width: 'auto' }}
          src={props.data.avatarImageUrl || 'https://quantumtrader.s3.amazonaws.com/defaultPayerAvatar.svg'}
        />
        {/* {payerIcon} */}
        <div className={css(styles.headingText)}>
          <div className={css(styles.headingTitle)}>
            {props.data.payerName}
          </div>
          <div className={css(styles.headingPayerCode)}>
            {`ID# ${props.data.payerId}`}
          </div>
        </div>
        <div
          className={css(styles.ellipsisContainer)}
          onClick={props.handleOnClickEllipsis}
          style={{ display: props.hideEllipsis ? 'none' : '' }}
        >
          <i className='fa fa-ellipsis-v' />
        </div>
      </div>
      {/* Body */}
      <div className='mt-3'>
        {/* Address */}
        <div className={css(styles.apwItem)}>
          <div className={css(styles.apwIconContainer)}>
            {/* <i className={`fa fa-map-marker ${css(styles.apwIcon)}`} /> */}
            <svg
              width="18"
              height="21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className='mt-2'
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.263 4.862a8.149 8.149 0 0 0-1.975-2.535A9.39 9.39 0 0 0 12.422.624 9.659 9.659 0 0 0 9.002 0h-.004c-1.17 0-2.32.21-3.42.624a9.39 9.39 0 0 0-2.866 1.703A8.14 8.14 0 0 0 .737 4.862 7.003 7.003 0 0 0 0 7.978c0 1.497.364 3.035 1.083 4.574.594 1.273 1.435 2.557 2.502 3.819 1.908 2.257 4.056 3.873 4.89 4.461a.905.905 0 0 0 1.05 0c.834-.588 2.984-2.204 4.89-4.461 1.064-1.262 1.908-2.546 2.502-3.82C17.636 11.014 18 9.473 18 7.979a6.996 6.996 0 0 0-.737-3.116Zm-8.264.687c-1.659 0-3.007 1.361-3.007 3.037S7.34 11.623 9 11.623c1.66 0 3.007-1.361 3.007-3.037S10.658 5.55 8.999 5.55Zm0 7.734a4.599 4.599 0 0 0 3.291-1.376 4.693 4.693 0 0 0 1.362-3.323A4.693 4.693 0 0 0 12.29 5.26 4.607 4.607 0 0 0 9 3.885 4.599 4.599 0 0 0 5.71 5.26a4.696 4.696 0 0 0-1.362 3.324c0 1.257.484 2.437 1.361 3.323A4.603 4.603 0 0 0 9 13.283Z"
                fill="#96C8FF"
              />
            </svg>
          </div>
          <div className={`ml-3 ${address.streetAddress1 ? '' : css(styles.apwError)}`}>
            {address.streetAddress1
              ? <div style={{ fontSize: '14px', marginTop: '-3px' }}>
                <a
                  href={pAddressUrl}
                  target='_blank'
                  rel="noreferrer"
                >
                  <div>{`${address.streetAddress1} ${address.suite}`}</div>
                  <div>{`${address.city}, ${address.state} ${address.zip}`}</div>
                </a>
              </div>
              : 'Address'
            }
          </div>
        </div>
        {/* Phone */}
        <div className={`fx fx__v-center mt-2 ${css(styles.apwItem)}`}>
          <div className={css(styles.apwIconContainer)}>
            {/* <i className={`fa fa-phone ${css(styles.apwIcon)}`} /> */}
            <svg
              width="21"
              height="20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.89 4.485c.163.375.295.766.39 1.166 1.61.491 2.724 2.011 2.727 3.735a3.877 3.877 0 0 1-1.146 2.757c-.4.402-.866.706-1.384.9a7.238 7.238 0 0 1-.585 2.472 7.294 7.294 0 0 1-1.616 2.337 7.5 7.5 0 0 1-2.391 1.572 7.582 7.582 0 0 1-2.811.576h-.116a2.578 2.578 0 0 1-1.802-.777 2.577 2.577 0 0 1-.746-1.82c0-.692.27-1.344.761-1.835a2.579 2.579 0 0 1 1.836-.761h.067c.667.018 1.295.29 1.768.766a2.588 2.588 0 0 1 .721 2.261 5.877 5.877 0 0 0 1.603-1.116 5.658 5.658 0 0 0 1.733-4.075V7.357a5.658 5.658 0 0 0-1.733-4.075 6.004 6.004 0 0 0-4.21-1.697c-1.59 0-3.086.603-4.211 1.7a5.658 5.658 0 0 0-1.733 4.074l.034 5.07a.779.779 0 0 1-.228.563.787.787 0 0 1-.728.218 3.873 3.873 0 0 1-1.945-1.062A3.886 3.886 0 0 1 0 9.388C0 8.533.268 7.72.775 7.04a3.846 3.846 0 0 1 1.853-1.36 7.295 7.295 0 0 1 2.016-3.532A7.502 7.502 0 0 1 7.035.576 7.655 7.655 0 0 1 9.958 0c1.011 0 1.996.194 2.924.576.896.37 1.702.9 2.392 1.572a7.308 7.308 0 0 1 1.616 2.337ZM.395 10.641Zm.222.496c.054.069.11.138.167.205-.057-.067-.113-.134-.167-.205Zm1.813.034a2.305 2.305 0 0 1-.844-1.784c0-.413.107-.82.308-1.174.138-.246.322-.462.536-.639v3.597Zm.2.393.084.083a1.416 1.416 0 0 1-.167-.167l.083.084Zm.147-5.745c.052-.096.11-.192.167-.288a2.73 2.73 0 0 0-.167.288Zm.125 7.161a2.102 2.102 0 0 0 .068.047l-.068-.046Zm1.093-.517v-.033c.01.01.01.022 0 .033ZM5.43 1.706c.043-.033.085-.067.129-.099a3.59 3.59 0 0 0-.13.099Zm.129-.099ZM7.154.721a4.88 4.88 0 0 0 .052-.02l-.052.02Zm1.276.997.058-.058a1.41 1.41 0 0 1 .116-.11c-.037.038-.077.075-.116.112l-.058.056Zm6.719.557Zm.125.125-.125-.125c.042.04.085.083.125.125Zm.374.413ZM10.727 18.11a1.004 1.004 0 0 1-.688.306H9.99a1.012 1.012 0 1 1 .737-.306Zm.544-.735a.08.08 0 0 1-.008-.03c.017.02.017.04.017.06 0-.01-.004-.02-.009-.03Zm1.117.812.083-.053a1.934 1.934 0 0 1-.166.106l.083-.053Zm2.668-.375.092-.088c.042-.04.085-.083.125-.125l-.125.125-.136.13c.014-.015.029-.029.044-.042Zm1.048-10.586c0 .02.004.043.008.064a.348.348 0 0 1 .008.065c0-.042 0-.087-.016-.13Zm.622 8.215Zm0 0a2.539 2.539 0 0 0 .024-.057l-.024.057ZM16.578 4.24Zm.148.317c.022.05.044.1.062.152-.02-.051-.04-.103-.063-.152Zm.372 1.1.166.166-.083-.083a9.59 9.59 0 0 0-.083-.084Zm.767 5.495Zm-.128-.127c-.08.08-.163.152-.253.219v-3.74c.24.179.445.404.601.667.219.367.333.786.333 1.217a2.29 2.29 0 0 1-.681 1.637Zm2.002-2.75.049.052c-.056-.057-.111-.113-.167-.167.044.038.081.077.118.116Zm-.29-.535a2.78 2.78 0 0 1 .067.067l-.067-.067Zm.116.115.05.052-.037-.039-.013-.013Zm.188 2.644c-.043.044-.086.09-.134.133l-.002.002.002-.002c.06-.054.12-.108.165-.165l-.03.032Z"
                fill="#96C8FF"
              />
            </svg>
          </div>
          <div className={`ml-3 ${phone === '' ? css(styles.apwError) : ''}`}>
            {phone === ''
              ? 'Phone'
              : <div style={{ marginTop: '-3px' }}>
                <a href={pPhoneUrl}>
                  {`(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6)}`}
                </a>
              </div>
            }
          </div>
        </div>
        {/* Fax */}
        <div className={`fx fx__v-center mt-2 ${css(styles.apwItem)}`}>
          <div className={css(styles.apwIconContainer)}>
            {/* <i className={`fa fa-phone ${css(styles.apwIcon)}`} /> */}
            <svg
              width="20"
              height="17"
              fill="none"
              className='mr-2'
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17 5h-1V0H6v5h-.78C4.67 4.39 3.89 4 3 4 1.34 4 0 5.34 0 7v7c0 1.66 1.34 3 3 3 .89 0 1.67-.39 2.22-1H20V8c0-1.66-1.34-3-3-3ZM4 14c0 .55-.45 1-1 1s-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v7ZM8 2h6v3H8V2Zm10 12H6V7h11c.55 0 1 .45 1 1v6Z" fill="#C0E0FF" /><path d="M13 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM16 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM13 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM16 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM11 8H7v5h4V8Z"
                  fill="#C0E0FF"
              />
            </svg>
          </div>
          <div className={`ml-3 ${phone === '' ? css(styles.apwError) : ''}`}>
            {fax === ''
              ? 'Fax'
              : <div style={{ marginTop: '-3px' }}>
                <a href={pPhoneUrl}>
                  {/* {fax} */}
                  {`(${fax.substring(0, 3)}) ${fax.substring(3, 6)}-${fax.substring(6)}`}
                </a>
              </div>
            }
          </div>
        </div>
        {/* Website */}
        <div className={`fx fx__v-center mt-2 ${css(styles.apwItem)}`}>
          <div className={css(styles.apwIconContainer)}>
            {/* <i className={`fa fa-globe ${css(styles.apwIcon)}`} /> */}
            <svg
              width="20"
              height="20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 10C0 4.48 4.379 0 9.786 0c5.417 0 9.806 4.48 9.806 10s-4.389 10-9.806 10C4.38 20 0 15.52 0 10Zm13.684-3.999h2.89a7.904 7.904 0 0 0-4.242-3.56 15.846 15.846 0 0 1 1.352 3.56ZM9.797 2.04c.813 1.2 1.45 2.53 1.87 3.96H7.927a14.214 14.214 0 0 1 1.87-3.96ZM1.96 10c0 .69.098 1.36.255 2h3.31c-.078-.66-.136-1.32-.136-2 0-.68.058-1.34.137-2H2.216a8.404 8.404 0 0 0-.255 2Zm1.055 4h2.89c.313 1.25.764 2.45 1.351 3.56A7.862 7.862 0 0 1 3.016 14Zm0-7.999h2.89c.313-1.25.764-2.45 1.351-3.56a7.862 7.862 0 0 0-4.241 3.56Zm6.78 11.959c-.812-1.2-1.449-2.53-1.87-3.96h3.742a14.212 14.212 0 0 1-1.871 3.96ZM7.505 12h4.585c.088-.66.157-1.32.157-2 0-.68-.069-1.35-.157-2H7.504c-.088.65-.156 1.32-.156 2 0 .68.068 1.34.156 2Zm4.828 5.56A15.846 15.846 0 0 0 13.684 14h2.89a7.904 7.904 0 0 1-4.242 3.56ZM14.203 10c0 .68-.058 1.34-.137 2h3.311a8.4 8.4 0 0 0 .255-2 8.4 8.4 0 0 0-.255-2h-3.31c.078.66.136 1.32.136 2Z"
                fill="#96C8FF"
              />
            </svg>
          </div>
          <div className={`ml-3 ${website === '' ? css(styles.apwError) : ''}`}>
            {website === ''
              ? 'Website'
              : <div
                className='text-truncate'
                style={{ maxWidth: '300px', marginTop: '-3px' }}
              >
                <a
                  href={pWebsite}
                  target='_blank'
                  rel="noreferrer"
                >
                  {pWebsite}
                </a>
              </div>
            }
          </div>
        </div>
        {/* Email */}
        <div className={`fx fx__v-center mt-2 ${css(styles.apwItem)}`}>
          <div className={css(styles.apwIconContainer)}>
            {/* <i className={`fa fa-globe ${css(styles.apwIcon)}`} /> */}
            <svg
              width="16"
              height="17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.38 5.98a3.574 3.574 0 0 0-.66-.06c-.413 0-.8.09-1.16.27-.36.18-.673.423-.94.73-.26.306-.467.66-.62 1.06-.153.393-.23.803-.23 1.23 0 .426.09.76.27 1 .187.233.457.35.81.35.173 0 .347-.027.52-.08.18-.054.35-.147.51-.28.16-.14.307-.324.44-.55.133-.227.243-.51.33-.85l.73-2.82Zm1.17 2.56c-.107.426-.16.776-.16 1.05.007.266.05.48.13.64a.66.66 0 0 0 .34.32c.147.06.313.09.5.09.28 0 .543-.087.79-.26.253-.18.473-.43.66-.75.187-.32.333-.7.44-1.14.113-.44.17-.92.17-1.44 0-.867-.137-1.63-.41-2.29a4.415 4.415 0 0 0-1.13-1.65 4.69 4.69 0 0 0-1.74-1 6.798 6.798 0 0 0-2.2-.34c-.88 0-1.693.166-2.44.5a6.051 6.051 0 0 0-1.95 1.35 6.321 6.321 0 0 0-1.29 2.03c-.307.78-.46 1.62-.46 2.52 0 1.093.17 2.056.51 2.89.34.826.807 1.52 1.4 2.08.593.553 1.29.97 2.09 1.25.807.28 1.677.42 2.61.42.513 0 .993-.03 1.44-.09.447-.054.857-.13 1.23-.23a7.328 7.328 0 0 0 1.02-.33c.307-.12.58-.25.82-.39.173-.1.327-.13.46-.09.133.04.23.14.29.3l.34.89c-.693.453-1.503.823-2.43 1.11-.927.286-1.983.43-3.17.43-1.207 0-2.323-.19-3.35-.57a7.742 7.742 0 0 1-2.67-1.64c-.747-.707-1.333-1.57-1.76-2.59C.21 10.59 0 9.443 0 8.17c0-.714.09-1.407.27-2.08a8.03 8.03 0 0 1 .79-1.89 8.114 8.114 0 0 1 2.83-2.9 7.797 7.797 0 0 1 1.9-.82 7.65 7.65 0 0 1 2.15-.3c.947 0 1.853.16 2.72.48a6.985 6.985 0 0 1 2.31 1.36 6.461 6.461 0 0 1 1.61 2.16c.4.846.6 1.803.6 2.87 0 .713-.107 1.383-.32 2.01-.207.62-.5 1.16-.88 1.62-.373.46-.817.823-1.33 1.09-.507.26-1.06.39-1.66.39-.46 0-.867-.107-1.22-.32-.353-.214-.597-.557-.73-1.03-.393.48-.81.823-1.25 1.03a3.32 3.32 0 0 1-1.43.31c-.42 0-.787-.074-1.1-.22a2.31 2.31 0 0 1-.78-.6 2.741 2.741 0 0 1-.47-.91 4.21 4.21 0 0 1-.15-1.15c0-.38.047-.764.14-1.15.1-.394.247-.77.44-1.13.193-.367.433-.707.72-1.02.293-.32.633-.597 1.02-.83.393-.24.833-.427 1.32-.56a5.919 5.919 0 0 1 1.62-.21c.52 0 .963.04 1.33.12.367.08.72.193 1.06.34l-.96 3.71Z"
                fill="#96C8FF"
              />
            </svg>
          </div>
          <div className={`ml-3 ${website === '' ? css(styles.apwError) : ''}`}>
            {email === ''
              ? 'Email'
              : <div
                className='text-truncate'
                style={{ maxWidth: '300px', marginTop: '-3px' }}
              >
                <a
                  href={`mailto:${email}`}
                  target='_blank'
                  rel="noreferrer"
                >
                  {email}
                </a>
              </div>
            }
          </div>
        </div>
        {/* Add Button / Servicing States */}
        {props.showAddBtn
          ? <div className='fx fx__hv-center mt-2'>
              <Button
                btnType='primary'
                isTextBtn
                onClick={props.onAddPayer}
              >
                Add Payer
              </Button>
            </div>
          : <div
            className='mt-2'
            style={{ color: blue[200], fontSize: '14px', fontWeight: '700' }}
          >
            Servicing States:&nbsp;
            <span style={{ fontSize: '14px', color: 'white' }}>
              {servicingStates}
            </span>
          </div>
        }
      </div>
    </div>
  );
};

PayerCardLarge.defaultProps = {
  className: '',
  hideEllipsis: false,
  showAddBtn: false,
  height: '323px'
};

export default PayerCardLarge;
